import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const permissionGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const requiredPrivileges: string[] = route.data?.['privileges'] || [];
  if (!requiredPrivileges.length) return true;   // route declares no privileges → allow

  // Same source the sidebar uses
  const userDetails = JSON.parse(localStorage.getItem('userDetails') || '{}');
  const privileges: string[] = userDetails?.privileges || [];
  const hasAccess = requiredPrivileges.some(rp => privileges.includes(rp));

  if (!hasAccess) {
    router.navigate(['/access-denied']);
    return false;
  }

  return true;
};
